// extracted by mini-css-extract-plugin
export default {"formContainer":"EditProfileScreen_formContainer__10P0Q"};